import { Navigate, useLocation } from 'react-router-dom';
import { fromRetiredMovements, peopleHref } from './peopleTodayUrl.js';

/**
 * `/attendance/movements` WAS A PAGE; the Overview's People list is where a
 * day's movements are read now. A link somebody kept still lands there, its
 * search, place, how and last day carried (`fromRetiredMovements`).
 */
export function MovementsRedirect(): JSX.Element {
  const { search } = useLocation();
  return <Navigate to={peopleHref(fromRetiredMovements(new URLSearchParams(search)))} replace />;
}
